import { AutomaticApprovalSettings, DataType } from "../../../Constant";

export const getAutomaticApprovalEnabled = (data) => {
  const item = data.find((entry) => entry.key === AutomaticApprovalSettings.Enable);
  return item ? item.value?.toLowerCase() === "true" : true;
};

export const mapAutomaticApprovalRows = (data, t) => {
  return data
    .map((item) => {
      let row = {};
      row["id"] = item.id;
      row["Key"] = item.key;

      switch (item.key) {
        case AutomaticApprovalSettings.ValidDays:
          row["Title"] = t("valid_days");
          break;
        case AutomaticApprovalSettings.DelayMin:
          row["Title"] = t("delay_min");
          break;
        case AutomaticApprovalSettings.TotalCostSEKMax:
          row["Title"] = t("total_cost_max");
          break;
        case AutomaticApprovalSettings.TransportationCostSEKMax:
          row["Title"] = t("transportation_cost_max");
          break;
        case AutomaticApprovalSettings.LinesToRemove:
          row["Title"] = t("lines_to_remove");
          break;
        case AutomaticApprovalSettings.StopsToRemove:
          row["Title"] = t("stops_to_remove");
          break;
        case AutomaticApprovalSettings.CompensationForOwnCar:
          row["Title"] = t("compensation_for_own_car");
          break;
        case AutomaticApprovalSettings.Level1CompensationForLongTrip:
          row["Title"] = t("level1_compensation_for_long_trip");
          break;
        case AutomaticApprovalSettings.Level1SizeCompensationForLongTrip:
          row["Title"] = t("level1_size_compensation_for_long_trip");
          break;
        case AutomaticApprovalSettings.Level2CompensationForLongTrip:
          row["Title"] = t("level2_compensation_for_long_trip");
          break;
        case AutomaticApprovalSettings.Level2SizeCompensationForLongTrip:
          row["Title"] = t("level2_size_compensation_for_long_trip");
          break;
        case AutomaticApprovalSettings.Level1CompensationForShortTrip:
          row["Title"] = t("level1_compensation_for_short_trip");
          break;
        case AutomaticApprovalSettings.Level1SizeCompensationForShortTrip:
          row["Title"] = t("level1_size_compensation_for_short_trip");
          break;
        case AutomaticApprovalSettings.Level2CompensationForShortTrip:
          row["Title"] = t("level2_compensation_for_short_trip");
          break;
        case AutomaticApprovalSettings.Level2SizeCompensationForShortTrip:
          row["Title"] = t("level2_size_compensation_for_short_trip");
          break;
        case AutomaticApprovalSettings.Level3CompensationForShortTrip:
          row["Title"] = t("level3_compensation_for_short_trip");
          break;
        case AutomaticApprovalSettings.Level3SizeCompensationForShortTrip:
          row["Title"] = t("level3_size_compensation_for_short_trip");
          break;
        case AutomaticApprovalSettings.MaxClaimsIn24Hours:
          row["Title"] = t("max_claims_in_24_hours");
          break;
        case AutomaticApprovalSettings.MaxClaimsDuring7Days:
          row["Title"] = t("max_claims_during_7_days");
          break;
        case AutomaticApprovalSettings.MaxClaimsDuring30Days:
          row["Title"] = t("max_claims_during_30_days");
          break;
        case AutomaticApprovalSettings.MaxOpenClaims:
          row["Title"] = t("max_open_claims");
          break;
        case AutomaticApprovalSettings.MaxMoneyToApprove:
          row["Title"] = t("max_money_to_approve");
          break;
        case AutomaticApprovalSettings.BasePriceFor30dayTicket:
          row["Title"] = t("base_price_for_30_day_ticket");
          break;
        case AutomaticApprovalSettings.BasePriceFor90dayTicket:
          row["Title"] = t("base_price_for_90_day_ticket");
          break;
        case AutomaticApprovalSettings.BasePriceFor360dayTicket:
          row["Title"] = t("base_price_for_360_day_ticket");
          break;
        case AutomaticApprovalSettings.MaxClaimsOnCommuterTicketIn24Hours:
          row["Title"] = t("max_claims_on_commuter_ticket_in_24_hours");
          break;
        case AutomaticApprovalSettings.MaxClaimsPerPeriodTicketAndTrip:
          row["Title"] = t("max_claims_per_period_ticket_and_trip");
          break;
        case AutomaticApprovalSettings.MaxClaimsOnSingleTicketPerTrip:
          row["Title"] = t("max_claims_on_single_ticket_per_trip");
          break;
        case AutomaticApprovalSettings.AutomaticRejectionIsEnabled:
          row["Title"] = t("automatic_rejection_is_enabled");
          break;
        case AutomaticApprovalSettings.AutomaticApprovalIsEnabled:
          row["Title"] = t("automatic_approval_is_enabled");
          break;
        case AutomaticApprovalSettings.SingleTicketAutomaticProcessingIsEnabled:
          row["Title"] = t("single_ticket_automatic_processing");
          break;
        case AutomaticApprovalSettings.CommuterTicketAutomaticProcessingIsEnabled:
          row["Title"] = t("commuter_ticket_automatic_processing");
          break;
        case AutomaticApprovalSettings.AllowedFileExtension:
          row["Title"] = t("allowed_file_extension");
          break;
        case AutomaticApprovalSettings.HoursUntilClaimsBeingProcessed:
          row["Title"] = t("hours_until_claims_being_processed");
          break;
        case AutomaticApprovalSettings.MonthToDeleteSensitiveData:
          row["Title"] = t("month_to_delete_sensitive_data");
          break;
        default:
          row["Title"] = item.key;
          break;
      }

      row["Value"] = item.value;
      row["FromDate"] = item.fromDate;
      row["DataType"] = item.dataType;
      row["ToDate"] = item.toDate;
      return row;
    })
    .filter((item) => item.Key !== AutomaticApprovalSettings.Enable)
    .sort((a, b) => a.Title.toUpperCase().localeCompare(b.Title.toUpperCase()));
};

export const isValidAutomaticApprovalValue = (row, value) => {
  if (row.DataType !== DataType.Int && row.DataType !== DataType.Decimal) {
    return true;
  }

  if (Number(value) < 0) {
    return false;
  }

  if (row.DataType === DataType.Int && !Number.isInteger(Number(value))) {
    return false;
  }

  if (
    (row.Key === AutomaticApprovalSettings.ShortTripValidDays || row.Key === AutomaticApprovalSettings.LongTripValidDays) &&
    Number(value) > AutomaticApprovalSettings.LongShortTripValidDaysMax
  ) {
    return false;
  }

  return true;
};